import { DefaultValues, useForm, UseFormReturn } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import DirectoFormSchema, { DirectoFormValues } from '../models/schema'
import { DirectoEventResponseStatusEnum } from '../../../../../api/models/directo-event-response'

export const initialFormData: DefaultValues<DirectoFormValues> = {
  customerId: -1,
  descriptionAddendum: '',
  status: DirectoEventResponseStatusEnum.IDLE,
}

function useDirectoForm() {
  const form: UseDirectoFormReturn = useForm<DirectoFormValues>({
    mode: 'onChange',
    reValidateMode: 'onChange',
    defaultValues: initialFormData,
    // possible access to context and options with refs to element inputs
    resolver(values, context, options) {
      return zodResolver(DirectoFormSchema)(values, context, options)
    },
  })

  return {
    form,
  }
}

export type UseDirectoFormReturn = UseFormReturn<DirectoFormValues>

export default useDirectoForm
